import { logger } from '../../../../utils/logger';

export default async function deleteChannel(
  authURL,
  selectedClient,
  token,
  pipelineId,
  channelId
) {
  try {
    const response = await fetch(
      `${authURL}/clients/${selectedClient}/pipeline/${pipelineId}/channels`,
      {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ channelId })
      }
    );

    if (response.ok) {
      const pipeline = await response.json();
      return pipeline;
    }
    const error = await response.json();
    logger(error.message);
    return null;
  } catch (error) {
    logger('Error connecting to server');
    return null;
  }
}
